// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__1Bqm7","list":"Breadcrumb_list__G8_ML","item":"Breadcrumb_item__OFSv0","link":"Breadcrumb_link__E6J_S"};